import { useState } from "react";
import { Toast, ToastContainer } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import { changelog } from "../../constants/changelog";
import {
  dismissWhatsNew,
  isOlderThanMonths,
  isWhatsNewDismissed,
} from "../../utils/whatsNewTracking";

const STALE_AFTER_MONTHS = 2;

const latest = changelog[0];
const toastMessage = "Global Quests and the GQ Mob Guide are now available.";
const latestMonth = (() => {
  const match = /^(\d{1,2})\/(\d{4})$/.exec(latest.title);
  if (!match) return latest.title;
  return new Intl.DateTimeFormat("en-US", {
    month: "long",
    year: "numeric",
    timeZone: "UTC",
  }).format(new Date(Date.UTC(Number(match[2]), Number(match[1]) - 1, 1)));
})();
// Keyed on title + changes (not just title) so a second entry added under an
// existing title (e.g. two "10/2025" entries) still re-triggers the toast.
const latestVersion = `${latest.title}|${latest.changes.join("|")}`;

const styles = {
  container: {
    zIndex: 1050,
  },
  toast: {
    width: "560px",
    maxWidth: "90vw",
    fontSize: "0.8rem",
    backgroundColor: "#2A2843",
    borderRadius: "0.375rem",
    overflow: "hidden",
  },
  header: {
    backgroundColor: "#201F33",
    color: "#98d8ff",
    padding: "0.4rem 0.6rem",
  },
  title: {
    fontSize: "0.85rem",
  },
  body: {
    backgroundColor: "#2A2843",
    color: "#f1f4c6",
    padding: "0.5rem 0.6rem",
  },
  changes: {
    marginBottom: "6px",
    paddingLeft: "1rem",
  },
};

function WhatsNewToast() {
  const [dismissed, setDismissed] = useState(() =>
    isWhatsNewDismissed(latestVersion)
  );

  if (dismissed || isOlderThanMonths(latest.title, STALE_AFTER_MONTHS)) {
    return null;
  }

  const handleClose = () => {
    dismissWhatsNew(latestVersion);
    setDismissed(true);
  };

  return (
    <ToastContainer
      position="bottom-center"
      containerPosition="fixed"
      className="p-3"
      style={styles.container}
    >
      <Toast onClose={handleClose} show style={styles.toast}>
        <Toast.Header style={styles.header} closeButton closeVariant="white">
          <strong className="me-auto" style={styles.title}>
            What's New — {latestMonth}
          </strong>
        </Toast.Header>
        <Toast.Body style={styles.body}>
          <p style={styles.changes}>{toastMessage}</p>
          <NavLink to="/changelog" className="brand-color" onClick={handleClose}>
            View the {latestMonth} changelog →
          </NavLink>
        </Toast.Body>
      </Toast>
    </ToastContainer>
  );
}

export default WhatsNewToast;
